import { createAsyncThunk } from '@reduxjs/toolkit'
import Translation from './translation-model'
import {
  delete_translation,
  load_translations,
  store_translation,
} from './translation-service'

export const LoadTranslationsAsync = createAsyncThunk<any, any>(
  'composer/load/translation',
  async (params: { uid: string }) => {
    return await load_translations(params)
  },
)

export const CreateTranslationAsync = createAsyncThunk<any, any>(
  'composer/create/translation',
  async (params: Translation) => {
    return await store_translation(params)
  },
)

export const DeleteTranslationAsync = createAsyncThunk<any, any>(
  'composer/delete/translation',
  async (params) => {
    return await delete_translation(params)
  },
)
